import { useTranslation } from 'react-i18next';

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section id="how">
      <div className="section-label">
        {t('landing.how.label', { defaultValue: 'Process' })}
      </div>

      <h2 className="section-title">
        {t('landing.how.title1', { defaultValue: 'From blank page to ' })}
        <em>{t('landing.how.title2', { defaultValue: 'perfect copy' })}</em>
        {t('landing.how.title3', { defaultValue: ' in three steps' })}
      </h2>

      <p className="section-sub">
        {t('landing.how.sub', {
          defaultValue:
            'No writing skills needed. Just describe yourself and let the AI do the rest.',
        })}
      </p>

      <div className="steps-grid">
        <div className="step">
          <span className="step-num">01</span>
          <div className="step-icon">✦</div>
          <h3>
            {t('landing.how.s1h', {
              defaultValue: 'Tell us about yourself',
            })}
          </h3>
          <p>
            {t('landing.how.s1p', {
              defaultValue:
                'Enter your niche, personality, and goals. The more detail you give, the more personal and on-brand your content will be.',
            })}
          </p>
        </div>

        <div className="step">
          <span className="step-num">02</span>
          <div className="step-icon">⚡</div>
          <h3>
            {t('landing.how.s2h', {
              defaultValue: 'AI generates your copy',
            })}
          </h3>
          <p>
            {t('landing.how.s2p', {
              defaultValue:
                'The generator turns your niche, tone, and goals into ready-to-use Instagram copy you can refine, save, and regenerate instantly.',
            })}
          </p>
        </div>

        <div className="step">
          <span className="step-num">03</span>
          <div className="step-icon">◈</div>
          <h3>
            {t('landing.how.s3h', {
              defaultValue: 'Publish and grow',
            })}
          </h3>
          <p>
            {t('landing.how.s3p', {
              defaultValue:
                "Copy your new bio or caption, paste into Instagram, and watch your engagement climb. Iterate instantly until it's perfect.",
            })}
          </p>
        </div>
      </div>
    </section>
  );
}
